import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CacheService {
    private cache = <any>{};

    constructor() {
    }

    set(key: string, value: any) {
        this.cache[key] = value;
    }

    get<T>(key: string): T {
        return this.cache[key];
    }

    getByHttpRequest<T>(url: string, params: any): T {
        return this.get<T>(url + JSON.stringify(params));
    }

    setByHttpRequest<T>(url: string, params: any, value: any) {
        this.set(url + JSON.stringify(params), value);
    }

    clearCache() {
        this.cache = <any>{};
    }

}
